var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.activity && _vm.activity.md)?_c('Markdown',{staticClass:"mt-4",attrs:{"title":_vm.$t2(_vm.activity.title),"content":_vm.activity.md,"content_en":_vm.activity.md,"lang":_vm.$i18n.locale}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }